module.exports = __webpack_public_path__ + "static/media/STHiFi5a.ecf1c36c.png";